type TraceStepLike = {
  ts: string
  stepOrder: number | null
}

export const sortTraceStepsByExecution = <T extends TraceStepLike>(steps: T[]): T[] =>
  [...steps].sort((a, b) => {
    const tsDiff = new Date(a.ts).getTime() - new Date(b.ts).getTime()
    if (tsDiff !== 0) {
      return tsDiff
    }
    return (a.stepOrder ?? 0) - (b.stepOrder ?? 0)
  })
